import moment, { type Moment } from 'moment-timezone'

interface DepositEligibility {
  allowedPaymentTypes: string[]
  finalPaymentDate: Moment
  timezone: string
  getRemainingPriceCents: () => number
}

export function isBeforeDepositDeadline(now: Moment, finalDate: Moment, timezone: string): boolean {
  // Checkout requires full payment throughout the deadline's local calendar day.
  const nowTz = now.clone().tz(timezone)
  return nowTz.isBefore(finalDate) && !nowTz.isSame(finalDate, 'day')
}

export function canPayDeposit(eligibility: DepositEligibility, now: Moment = moment()): boolean {
  return (
    eligibility.allowedPaymentTypes.includes('deposit') &&
    isBeforeDepositDeadline(now, eligibility.finalPaymentDate, eligibility.timezone) &&
    eligibility.getRemainingPriceCents() > 0
  )
}
